module.exports = __webpack_public_path__ + "static/media/arrowIcon.6a666f2a.webp";